import { atoms, Button, Link } from '@zapier/marketing-ui';
import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';
import { useEffect } from 'react';
import { dispatchUserInteractionEvent } from '../../../avro';
import { DomainAccessPolicyType } from '../../../utils/discoverDomain';
import { Modal, ModalBody, ModalFooter } from '../Modal';
import { ActionButton } from './ActionButton/ActionButton';
import { InstructionContent } from './InstructionContent/InstructionContent';

type Props = {
  onClickUseDifferentEmail: () => void;
  onClickJoinTeam: () => void;
  onClickGoToHomepage: () => void;
  teamName?: string;
  teamAvatarUrl?: string;
  accessPolicy?: DomainAccessPolicyType;
  teamDomain?: string;
  isDomainCaptureBlocked?: boolean;
};

export function FoundTeamModal({
  onClickUseDifferentEmail,
  onClickJoinTeam,
  onClickGoToHomepage,
  teamName,
  accessPolicy,
  teamDomain,
  isDomainCaptureBlocked,
}: Props) {
  useEffect(() => {
    void dispatchUserInteractionEvent({
      event_action: 'click',
      option_selected: 'DOMAIN_DISCOVERY_show_modal',
      interaction_name: 'DOMAIN_DISCOVERY_show_modal',
      interaction_raw_text: 'Show the FoundTeam Modal',
      interaction_goal: 'Displays the Domain Discovery FoundTeam Modal',
    });
  }, []);

  const isAutoJoin = accessPolicy === DomainAccessPolicyType.auto_join;
  const nonEmptyTeamName = !isEmpty(trim(teamName)) ? teamName : teamDomain;

  return (
    <Modal
      title="Good news, we found your team!"
      onClose={onClickUseDifferentEmail}
    >
      <ModalBody>
        <p>
          Your colleagues at{' '}
          <span className={atoms.fontSemibold}>{nonEmptyTeamName}</span> are
          using Zapier.
        </p>
        <InstructionContent
          isAutoJoin={isAutoJoin}
          isDomainCaptureBlocked={isDomainCaptureBlocked ?? false}
        />
        <p>
          Having trouble?{' '}
          <Link
            target="_blank"
            href="https://help.zapier.com/hc/en-us/articles/26165062819725"
          >
            Get help signing up
          </Link>
        </p>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="secondary"
          size="small"
          onClick={onClickUseDifferentEmail}
        >
          Use a different email
        </Button>
        <ActionButton
          isAutoJoin={isAutoJoin}
          isDomainCaptureBlocked={isDomainCaptureBlocked ?? false}
          onClickGoToHomepage={onClickGoToHomepage}
          onClickJoinTeam={onClickJoinTeam}
        />
      </ModalFooter>
    </Modal>
  );
}
